export const recipeStoreTypes = {
  actions: {
    getLatestRecipes: "GET_LATEST_RECIPES",
    getRecipesByCategory: "GET_RECIPES_BY_CATEGORY",
    getRecipe: "GET_RECIPE",
  },
};
